import React from "react";
import MaButton from "../../../../Components/UI/ma-button";
import { TfiDownload } from "react-icons/tfi";

export function OrdersPageHeader({ onExport }) {
  return (
    <div className="mb-8 flex flex-row gap-4 sm:flex-row sm:items-start justify-between">
      <div>
        <h1 className="my-0 text-[22px] font-semibold tracking-tight text-[#151515] md:text-[24px]">
          Orders
        </h1>
        <p className="my-0 mt-1.5 text-[13px] leading-relaxed text-[#6B7280]">
          Manage incoming and active orders
        </p>
      </div>
      <MaButton
        startIcon={<TfiDownload className="text-[15px]" />}
        onClick={onExport}
        sx={{
          alignSelf: "flex-start",
          textTransform: "none",
          color: "#151515",
          borderColor: "#E5E7EB",
          bgcolor: "#FFFFFF",
          border: "1px solid #E5E7EB",
          borderRadius: "999px",
          px: 2.5,
          minHeight: "42px",
          fontWeight: 600,
          fontSize: "13px",
          "&:hover": {
            borderColor: "#D1D5DB",
            bgcolor: "#F9FAFB",
          },
        }}
      >
        Export
      </MaButton>
    </div>
  );
}
